import { getCoords, getType } from "@turf/invariant";

/**
 * Geometry with GeoJSON Polygon/MultiPolygon shape (type + coordinates).
 * Accepts both GeoJSON types and API types (e.g. ISchoolBoundaryGeometry).
 */
type PolygonLikeGeometry =
  | { type: string; coordinates?: unknown }
  | null
  | undefined;

/**
 * Extracts the first (exterior) ring from GeoJSON Polygon or MultiPolygon geometry
 */
export function getFirstRingFromGeometry(
  geometry: PolygonLikeGeometry,
): number[][] | null {
  if (!geometry?.coordinates || !Array.isArray(geometry.coordinates)) {
    return null;
  }

  const type = getType(geometry as GeoJSON.Geometry);

  if (type === "Polygon") {
    const coords = getCoords(geometry as GeoJSON.Polygon) as number[][][];
    const ring = coords[0];
    return ring ?? null;
  }

  if (type === "MultiPolygon") {
    const coords = getCoords(geometry as GeoJSON.MultiPolygon) as number[][][][];
    const firstPolygon = coords[0];
    const ring = firstPolygon?.[0];
    return ring ?? null;
  }

  return null;
}
